import { Flex, chakra } from '@chakra-ui/react';
import React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const MainAreaTop = ({ children, className }: Props) => {
  return (
    <Flex
      background="black"
      flexDir="column"
      className={ className }
      w="100%"
      m="0 auto"
      alignItems="stretch"
      paddingY={ 10 }
    >
      { children }
    </Flex>
  );
};

export default React.memo(chakra(MainAreaTop));
